﻿import { RoleSigningStatusDto } from 'services/api/api-client.types.ts';
import { BrightTooltip } from 'components/tooltips/BrightTooltip.tsx';
import { getRoleShortName } from 'helpers/role-helper.ts';
import styles from './SigningRoleIcon.module.scss';
import iconStyles from './IconStyles.module.scss';
import { FC } from 'react';
import { createId } from 'components/uikit/type-utils.ts';
import clsx from 'clsx';
import { RemoveBadge } from './RemoveBadge.tsx';
import { getStyleFromStatus, getTextFromStatus } from './helpers.ts';

export type SigningRoleIconProps = {
  dto: RoleSigningStatusDto;
  onRemove: (roleId: number) => void;
};

export const SigningRoleIcon: FC<SigningRoleIconProps> = (props) => {
  return (
    <RemoveBadge
      enabled={props.dto.isDeletable}
      className={clsx(
        iconStyles.icon,
        getStyleFromStatus(props.dto.status, true),
      )}
      position={{ top: -10, left: 22 }}
      onClick={() => props.onRemove(props.dto.role.id)}
      key={props.dto.role.id}
    >
      <BrightTooltip
        key={createId()}
        title={<SigningRoleTooltip key={props.dto.role.id} dto={props.dto} />}
        placement="bottom"
      >
        <div
          className={getStyleFromStatus(props.dto.status, true)}
          data-test-id={'signingRoleIcon'}
        >
          {getRoleShortName(props.dto.role.name)}
        </div>
      </BrightTooltip>
    </RemoveBadge>
  );
};

type SigningRoleTooltipProps = {
  dto: RoleSigningStatusDto;
};

const SigningRoleTooltip: FC<SigningRoleTooltipProps> = (props) => {
  return (
    <div className={styles.tooltip} data-test-id={'signingRoleTooltip'}>
      <div className={styles.tooltipTitle}>{props.dto.role.name}</div>
      <div className={styles.tooltipItems}>
        {props.dto.role.signers?.map((e) => (
          <div className={styles.tooltipItem}>
            {e.signer.firstName} {e.signer.lastName}
          </div>
        ))}
      </div>
      <div
        className={clsx(
          getStyleFromStatus(props.dto.status, false),
          styles.tooltipComment,
        )}
      >
        {getTextFromStatus(props.dto.status)}
      </div>
    </div>
  );
};
